/* Approved Save badge motion. No DOM insertion inside React-owned elements. */
(()=>{
  const initialized=new WeakSet(),reduced=matchMedia('(prefers-reduced-motion: reduce)');
  function init(root){
    if(initialized.has(root))return;
    const saves=[...root.querySelectorAll('.ps-save')];
    if(saves.length!==2)return;
    initialized.add(root);
    let visible=false,timer=0,offsetTimer=0;
    const clears=new Map();
    function burst(save){
      if(!root.isConnected||!visible||document.hidden||reduced.matches||save.classList.contains('is-burst'))return;
      save.classList.add('is-burst');
      clears.set(save,setTimeout(()=>{save.classList.remove('is-burst');clears.delete(save);},950));
    }
    function stop(){clearTimeout(timer);clearTimeout(offsetTimer);}
    function cycle(){stop();if(!root.isConnected||!visible||document.hidden||reduced.matches)return;burst(saves[0]);offsetTimer=setTimeout(()=>burst(saves[1]),1700);timer=setTimeout(cycle,7000);}
    function restart(){
      stop();clears.forEach(clearTimeout);clears.clear();saves.forEach(s=>s.classList.remove('is-burst'));
      if(!root.isConnected){observer.disconnect();resize.disconnect();document.removeEventListener('visibilitychange',restart);reduced.removeEventListener('change',restart);return;}
      if(visible&&!document.hidden&&!reduced.matches)timer=setTimeout(cycle,450);
    }
    function spacing(){saves.forEach(s=>{const card=s.closest('.offer-option'),text=card.querySelector('.offer-text');const cs=getComputedStyle(card),pad=cs.paddingBottom,height=(parseFloat(cs.height)-parseFloat(cs.borderTopWidth)-parseFloat(cs.borderBottomWidth)-parseFloat(cs.paddingTop))+'px';if(text.style.getPropertyValue('--ps-text-height')!==height)text.style.setProperty('--ps-text-height',height);if(text.style.getPropertyValue('--ps-card-pad')!==pad)text.style.setProperty('--ps-card-pad',pad);});}
    const resize=new ResizeObserver(spacing);saves.forEach(save=>resize.observe(save.closest('.offer-option')));spacing();
    saves.forEach(save=>{const card=save.closest('.offer-option');save.addEventListener('pointerenter',()=>burst(save));card.addEventListener('focusin',()=>burst(save));card.addEventListener('click',()=>{requestAnimationFrame(spacing);burst(save);});});
    const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;restart();},{threshold:.25});observer.observe(root.querySelector('.offer-options'));
    document.addEventListener('visibilitychange',restart);reduced.addEventListener('change',restart);
  }
  function scan(){const root=document.querySelector('#product #offers');if(root)init(root);}
  scan();
  const mount=document.getElementById('presteem-root');
  if(mount)new MutationObserver(scan).observe(mount,{childList:true,subtree:true});
})();
